import { FC, PropsWithChildren } from 'react';
import { ThemeProvider } from '@mui/material';

import { theme } from './theme';

export const ThemeContextProvider: FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
